// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	"js/manifest": 0,
	"css/templates/single-publication": 0,
	"css/templates/single-person": 0,
	"css/templates/index": 0,
	"css/templates/404": 0,
	"css/app": 0,
	"css/blocks/what-we-do": 0,
	"css/blocks/related-posts": 0,
	"css/blocks/recent-achievements": 0,
	"css/blocks/recent-accomplishments": 0,
	"css/blocks/publications-hub": 0,
	"css/blocks/priorities": 0,
	"css/blocks/posts-grid-section": 0,
	"css/blocks/our-team": 0,
	"css/blocks/our-mission": 0,
	"css/blocks/introductory-content-sm": 0,
	"css/blocks/introductory-content": 0,
	"css/blocks/hero-home": 0,
	"css/blocks/funders-statement": 0,
	"css/blocks/featured-press": 0,
	"css/blocks/featured-pieces": 0,
	"css/blocks/donate": 0,
	"css/blocks/cta-banner": 0,
	"css/blocks/content": 0,
	"css/blocks/contact-us": 0,
	"css/blocks/careers": 0,
	"css/blocks/campaigns-tabs": 0
};

// no chunk on demand loading

// no prefetching

// no preloaded

// no HMR

// no HMR manifest

__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);

// install a JSONP callback for chunk loading
var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
	var [chunkIds, moreModules, runtime] = data;
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
		for(moduleId in moreModules) {
			if(__webpack_require__.o(moreModules, moduleId)) {
				__webpack_require__.m[moduleId] = moreModules[moduleId];
			}
		}
		if(runtime) var result = runtime(__webpack_require__);
	}
	if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
	for(;i < chunkIds.length; i++) {
		chunkId = chunkIds[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}
	return __webpack_require__.O(result);
}

var chunkLoadingGlobal = self["webpackChunkskeleton_theme"] = self["webpackChunkskeleton_theme"] || [];
chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));